import { Component, inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LoadingService } from '../../services/loading.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { NgxToastrService } from '../../_services/ngx-toastr/ngx-toastr.service';
import { HttpServiceService } from '../../services/http-service.service';
import { NgClass, NgIf } from '@angular/common';
import { BreadcrumbComponent } from '../../elements/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-change-password',
  imports: [BreadcrumbComponent, ReactiveFormsModule, NgIf, NgClass],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.css'
})
export class ChangePasswordComponent {
  breadcrumbList = {
    breadcrumb_path: 'Dashboard',
    currentURL: 'Change Password',
    breadcrumb_url : ''
  }
  hide_show: boolean = false;
  confirm_hide_show : boolean = false;
  old_password_hide_show : boolean = false;
  resetForm!: FormGroup;
  loadingService = inject(LoadingService);
  private httpService = inject(HttpServiceService);
  changePasswordSubscription : Subscription | undefined;

  constructor(private fb: FormBuilder, private alertService: NgxToastrService){
    this.resetForm = this.fb.group({      
      password : ['', [Validators.required, Validators.minLength(6), Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$(!%*?&)_-])[A-Za-z\d@$!(%*?&)-_]{6,}$/)]],
      confirmPassword : ['', [Validators.required]],
      old_password : ['', [Validators.required]]
    }, { validators: this.passwordMatchValidator });
  }

  passwordHide(){
    this.hide_show = !this.hide_show;
  }

  confirmPasswordHide(){
    this.confirm_hide_show = !this.confirm_hide_show;
  }

  oldPasswordHide(){
    this.old_password_hide_show = !this.old_password_hide_show;
  }

  passwordMatchValidator(control: AbstractControl) {
    const password = control?.get('password')?.value;
    const confirmPassword = control?.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  onSubmit(){
    if (this.resetForm.valid) {
      let obj  = {
        oldPassword : this.resetForm?.value['old_password'],
        newPassword : this.resetForm?.value['password']
      }
      this.changePasswordSubscription = this.httpService.changePassword(obj).subscribe({
        next : (response) => {
          this.resetForm.reset();
          this.alertService.success(response.message, "toast-top-right");
        },
        error : (error) => {

        }
      })
    }
  }

  get password() { return this.resetForm!.get('password'); }
  get confirmPassword() { return this.resetForm!.get('confirmPassword'); }

  ngOnDestroy() {    
    this.changePasswordSubscription?.unsubscribe();
  }

}
